module.exports = __webpack_public_path__ + "static/img/aboutus-t.d2c4be3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/aboutus-t.png
// module id = EsHb
// module chunks = 4